<template>
  <div class="layout-2019 full-wrapper pannel">
      <!-- Timelne -->
      <el-scrollbar class="bar-visible" :ref="scrollbarRef">
      <div class="full">
        <w-summary-event-info :active="active"></w-summary-event-info>
        <el-row>
          <div class="row">
            <el-col>
              <w-summary-configuration-status ref="rootConfStatus" :active="active"></w-summary-configuration-status>
            </el-col>
            <el-col :md="24" :lg="12" v-for="(index, item) in 2" :key="index">
              <w-summary-perf-top-card :ref="`rootSummaryTopCard-${index}`" @showChartSettingPopup="showChartSettingPopup" :item="item" :active="active" :widgetPosition="index"></w-summary-perf-top-card>
            </el-col>
            <el-col>
              <w-summary-work-count ref="rootWorkCount" :active="active"></w-summary-work-count>
            </el-col>
          </div>
        </el-row>
        <w-timeline ref="rootTimeline" :active="active"></w-timeline>
      </div>
    </el-scrollbar>
    <w-scroll-top-button :visible="enableScollTop" @move-scroll-top="moveScrollTop"/>
    <w-summary-perf-chart-setting-popup ref="perfChartSettingPopup" @settingChartData="loadData"></w-summary-perf-chart-setting-popup>
  </div>
</template>

<script>
import { isNil } from 'lodash';
import ScrollbarMixin from '@/mixins/scrollbar';
import WTimeline from './Timeline';
import WSummaryPerfTopCard from './SummaryPerfTopCard';
import WSummaryConfigurationStatus from './SummaryConfigurationStatus';
import WSummaryWorkCount from './SummaryWorkCount';
import WSummaryPerfChartSettingPopup from './popup/SummaryPerfChartSettingPopup';
import WSummaryEventInfo from './SummaryEventInfo';

export default {
  name: 'WRootSummary',
  components: {
    WTimeline,
    WSummaryPerfTopCard,
    WSummaryConfigurationStatus,
    WSummaryWorkCount,
    WSummaryPerfChartSettingPopup,
    WSummaryEventInfo,
  },
  props: {
    active: {
      type: Boolean,
    },
  },
  mixins: [ScrollbarMixin],
  mounted() {
    this.setScrollData();
  },
  methods: {
    showChartSettingPopup(widgetPosition) {
      this.$refs.perfChartSettingPopup.open(widgetPosition);
    },
    loadData(widgetPosition) {
      this.$refs.rootTimeline.loadData();
      this.$refs.rootConfStatus.loadData();
      this.$refs.rootWorkCount.loadData();
      if (!isNil(widgetPosition)) {
        this.$refs[`rootSummaryTopCard-${widgetPosition}`][0].loadData(widgetPosition);
      } else {
        const firstCardRef = this.$refs['rootSummaryTopCard-1'];
        firstCardRef[0].loadData();
        const secondCardRef = this.$refs['rootSummaryTopCard-2'];
        secondCardRef[0].loadData();
      }
    },
  },
};
</script>

<style module>
</style>



// WEBPACK FOOTER //
// src/views/performance/root/components/RootPerfSummary.vue